import FinanceSerializer from './base';
import { isEmpty } from '@ember/utils';

export default class Transaction extends FinanceSerializer {
  normalize(modelClass, payload) {
    let defaults = {
      isPosted: false,
      xeroBatchNo: null,
    };
    payload.amount = ((payload.amount ?? 0) / 100).toFixed(2);
    payload.amountRefunded = ((payload.amountRefunded ?? 0) / 100).toFixed(2);
    if (isEmpty(payload.xeroBatchNo) && payload.isPosted) {
      payload.xeroBatchNo = 0;
    }
    Object.assign(defaults, payload);
    Object.assign(payload, defaults);
    return super.normalize(...arguments);
  }

  serialize() {
    let hash = super.serialize(...arguments);
    hash.ledgerItemId = parseInt(hash.ledgerItemId, 10);
    hash.lineItemId = parseInt(hash.lineItemId, 10);
    hash.sourceTransactionId = parseInt(hash.sourceTransactionId, 10);
    hash.accountId = parseInt(hash.accountId, 10);
    hash.tillSessionId = parseInt(hash.tillSessionId, 10);
    hash.amount = Math.round(hash.amount * 100);
    hash.amountRefunded = Math.round(hash.amountRefunded * 100);
    return hash;
  }
}
